module.exports = __webpack_public_path__ + "img/GuaHaoIcon.58b43ae5.svg";